import React, { useEffect } from "react";
import {
  Body,
  CmsSpacer,
  Display,
  GutterContainer,
  Keyline,
  LinkText,
  TemplateFullGutter
} from "@common/AggregationComponent";
import { useLocation } from "react-router-dom";
import {
  getBrandForMeta,
  transformBrandForGoogleAnalytics
} from "@util/common";
import { Helmet } from "react-helmet-async";
import type { CombinedReducersType } from "@type/index";
import { getPageViewBaseOption, trackPageView } from "@util/gtm";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { IS_ENV } from "@util/config";

const NotFound = (): any => {
  const { t } = useTranslation();
  const location = useLocation();
  const config = useSelector((store: CombinedReducersType) => store.app);
  const BASE_PATH_NAME = `/${config.region}/${config.language}`;

  useEffect(() => {
    const isFinalTitle = document.title === t("text_404");
    const isNotDefaultTitle = document.title !== "text_404";
    if (window.dataLayer && isFinalTitle && isNotDefaultTitle) {
      trackPageView(
        getPageViewBaseOption(
          t("text_404"),
          transformBrandForGoogleAnalytics(config.brand_name)
        )
      );
    }
  }, [document.title, t, location]);
  return (
    <>
      <Helmet
        titleTemplate={t("text_404")}
        defaultTitle={t("text_404")}
        htmlAttributes={{ lang: config.language }}
      >
        <meta
          name="description"
          content={t("text_404_error_description", {
            text_uqtop: t("text_image_search_go_to_top"),
            text_contactus: t("text_contactus")
          })}
        />
        <meta property="og:site_name" content={getBrandForMeta()} />
        <meta property="og:title" content={t("text_404")} />
        <meta property="og:description" content={""} />
        <meta property="og:image" content={""} />
        <meta property="fb:app_id" content={""} />
        <meta name="twitter:card" content={"summary"} />
        <meta name="twitter:site" content={getBrandForMeta()} />
        <meta name="twitter:title" content={t("text_404")} />
        <meta name="twitter:image" content={""} />
        <meta
          property="og:url"
          content={`${window.origin}${BASE_PATH_NAME}/image-search`}
        />
      </Helmet>
      <TemplateFullGutter
        mainContent={
          <GutterContainer>
            <div className="fr-ec-mb-spacing-05" />
            <Display
              lang={config.language}
              element="h1"
              variant="display3"
              className="fr-ec-mb-spacing-04"
            >
              {t("text_404")}
            </Display>
            <Keyline className="fr-ec-mb-spacing-05" />
            <Body
              element="p"
              variant="standard"
              className="fr-ec-mb-spacing-06"
            >
              {t("text_404_error_description", {
                text_uqtop: t("text_image_search_go_to_top"),
                text_contactus: t("text_contactus")
              })}
            </Body>
            <CmsSpacer spaces="xs" />
            <Body
              element="p"
              variant="standard"
              className="fr-ec-mb-spacing-02"
            >
              <LinkText
                ariaLabel="aria Label"
                element="a"
                href={`${BASE_PATH_NAME}/`}
                variant="standalone-secondary"
                className="fr-ec-mb-spacing-02"
              >
                {t("text_image_search_go_to_top")}
              </LinkText>
            </Body>
            <Body element="p" variant="standard">
              <LinkText
                element="a"
                href={IS_ENV(config.region, config.brand_name).faqUrl}
                variant="standalone-secondary"
              >
                {t("text_contactus")}
              </LinkText>
            </Body>
          </GutterContainer>
        }
      />
    </>
  );
};

export default NotFound;
